// eslint-disable-next-line import/no-unresolved
import { TypedAction } from '@ngrx/store/src/models';

import { ApiWishlist, WLItem, Wishlist } from '../../domain/models/wishlist.models';

import { ProductPublicModels } from '@features/products/product';
import { ErrorInfo } from '@shared/errors/models/error.models';
import { ShowError } from '@shared/errors/store/errors.actions';

export function MapWishlistItemsUseCase(wishlist: ApiWishlist, products: ProductPublicModels.PublicProduct[]): Wishlist {
    return {
        name: wishlist.name,
        items: ParseProductsWishUseCase(wishlist.items, products),
    };
}

export function GetIDsAsStringUseCase(items: WLItem[]): string {
    const uniqueProductIds = new Set<string>();

    // biome-ignore lint/complexity/noForEach: <explanation>
    items?.forEach((item) => {
        if (item?.catentryId) {
            uniqueProductIds.add(item.productId?.toString());
        }
    });

    const uniqueIdsArray: string[] = Array.from(uniqueProductIds);
    return uniqueIdsArray.join();
}

export function ParseProductsWishUseCase(
    items: WLItem[],
    products: ProductPublicModels.PublicProduct[]
): ProductPublicModels.PublicProduct[] {
    const matchedProducts: ProductPublicModels.PublicProduct[] = [];
    const addedProducts: Set<string> = new Set();
    // biome-ignore lint/complexity/noForEach: <explanation>
    items?.forEach((item) => {
        const matchProduct = products?.find((prod) => prod.id === item.productId);

        const selectedColor: ProductPublicModels.PublicProductColor = matchProduct?.colors?.find((color) => {
            return color.sizes.find((size) => size.sku.toString() === item.catentryId);
        });

        if (selectedColor) {
            const selectedSize = selectedColor.sizes.find((size) => size.sku.toString() === item.catentryId);

            const uniqueProductKey = `${item.productId}-${item.catentryId}`;
            if (!addedProducts.has(uniqueProductKey)) {
                matchedProducts.push({
                    ...matchProduct,
                    priceInfo: selectedSize?.priceInfo ?? selectedColor?.sizes[0].priceInfo,
                    status: {
                        selectedColor,
                        selectedSize,
                        hideSize: true,
                    },
                });
            }
            addedProducts.add(uniqueProductKey);
        }
    });

    return matchedProducts;
}

export function SetModalErrorUseCase(error: any): TypedAction<string> & { error: ErrorInfo; kind: 'general' | 'shopcart' | 'summaryPrivacyPolicy' } {
    let modalAction: TypedAction<string> & {
        error: ErrorInfo;
        kind: 'general' | 'shopcart' | 'summaryPrivacyPolicy';
    };

    if (error.key === 'HTTP_PAYLOAD_TOO_LARGE') {
        const errorInfo: ErrorInfo = {
            subtitle: 'dev.cart.wishlist.maxSizeItems',
        };
        modalAction = ShowError({ error: errorInfo, kind: 'general' });
    } else {
        modalAction = ShowError({ error: { subtitle: 'dev.cart.catchErrorTitle' }, kind: 'general' });
    }

    return modalAction;
}
